import { RefreshableItem } from '../models/refreshableItem';
import { isEnumType } from './urlParameters';

export const getValidRefreshableItems = (refreshableItemsQueryValue = '') => {
  return refreshableItemsQueryValue.split(',').filter(isEnumType(RefreshableItem));
};

export const containsInvalidRefreshableItem = (rawRefreshableItems: string) => {
  const rawParsedRefreshableItems = rawRefreshableItems.split(',').filter(Boolean);
  const validRefreshableItems = getValidRefreshableItems(rawRefreshableItems);

  return rawParsedRefreshableItems.length > validRefreshableItems.length;
};
